/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  SearchCountryField,
  CountryISO,
  PhoneNumberFormat,
  NgxIntlTelInputModule,
} from 'ngx-intl-tel-input';
import {
  AbstractControl,
  FormBuilder,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../shared/common/common.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { routes } from '../../shared/routes/routes';
import { CommonModule } from '@angular/common';
import { CommonStandaloneImports } from '../../shared/common/common-standalone-imports';
import moment from 'moment';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TermsConditionComponent } from '../../components/terms-condition/terms-condition';
import { PrivacyPolicyComponent } from '../../components/privacy-policy/privacy-policy';
import { BookingLogService } from '../../services/booking-log.service';
import { CONSTANT } from '../../shared/constants/global-constant';
import { NgSelectModule } from '@ng-select/ng-select';

import * as mapboxgl from 'mapbox-gl';
import { environment } from '../../../environments/environment';
import { finalize } from 'rxjs';

declare var bootstrap: any;
@Component({
  standalone: true,
  selector: 'app-modal',
  imports: [
    ...CommonStandaloneImports,
    NgxIntlTelInputModule,
    NgxSpinnerModule,
    BsDatepickerModule,
    TermsConditionComponent,
    PrivacyPolicyComponent,
    NgSelectModule,
  ],
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnChanges, OnInit {
  patientList: any = [];
  slotsList: any[] = [];
  isehteen: boolean = false;
  userProfile = '';
  previewImage = '';
  showDescription: boolean = false;
  ambulanceUpdateData: any;
  addedMedicalDetails: any;
  uploadedFileName: string = '';
  minDate: string = '';
  maxDate: string = '';
  separateDialCode = false;
  isMobile: boolean = false;
  isSubmittingtelemedi: boolean = false;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  alaCartPriceOption: boolean = true;
  completeTelemedSub: boolean = false;
  isFieldDisabled: boolean = false;
  currencyPrice: number = 0;
  telResFormData: any = {};
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.UnitedKingdom,
  ];
  public routes = routes;
  medicalForm: any;
  selectedFile: File | null = null;
  myDateValue!: Date;
  subTelemedCount: number = 0;
  date = new Date();
  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('fileInput1') fileInput1!: ElementRef;
  @ViewChild('fileInput2') fileInput2!: ElementRef;
  @ViewChild('dp1') datepicker: any;
  @ViewChild('dpMedical') dpMedicalPicker: any;
  @ViewChild('dp') birthdatepicker: any;
  pdfUrl: any;
  uploadedPhoto: any;
  editData: any;
  uploadedFile: any;
  ambulanceForm: any;
  teleMedicineConsultForm: any;
  userProfiles: any;
  EditambulanceForm: any;
  modalElement: any;
  bsDatepickerConfig: any;
  medicalbsDatepickerConfig: any;
  isReschedule: boolean = false;
  isUpdated: boolean = false;
  maxChars: any = 200;
  text: any = '';
  charCount: any = 0;
  constant = CONSTANT;
  selectedRecord: any;
  medicalReportList: any = [];
  unlockMedicalList: any = [];
  selectedReason: string = '';
  selectedMinute: number | null = null;
  reasons: string[] = [
    'I am Busy',
    'Schedule conflict',
    'Patient condition has improved',
    'Booked by mistake',
    'Going to a different hospital',
  ];
  minutes = [
    { label: '15 minutes before', value: 15 },
    { label: '30 minutes before', value: 30 },
    { label: '1 hour before', value: 60 },
    { label: '2 hours before', value: 120 },
    { label: '1 day before', value: 1440 },
    { label: '2 days before', value: 2880 },
  ];
  selectedAppointment: any;
  selectedOptions: string[] = [];
  telemediPatientHasPhone: boolean = true;
  ambulancePatientHasPhone: boolean = true;

  rating = 0;
  review = '';
  ratingQuesAns: any;
  selectedAnswers: any = {};

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private spinner: NgxSpinnerService,
    private apiService: ApiService,
    private tosterService: ToastrService,
    private commonService: CommonService,
    private bookingLogService: BookingLogService,
  ) {}

  @Input() modalData: any;
  ngOnChanges(changes: SimpleChanges): void {}

  routeDuration!: string;
  routeDistance!: string;
  isMapLoading = false;

  pickupCoords!: [number, number];
  dropCoords!: [number, number];

  map!: mapboxgl.Map;
  marker!: mapboxgl.Marker;

  showMap = false;
  mapType: 'pickup' | 'drop' = 'pickup';
  mapMode: 'select' | 'route' = 'select';
  mapLoaded = false;

  selectedLat!: number;
  selectedLng!: number;
  selectedAddress = '';

  pickupAddressDetails: any;
  dropAddressDetails: any;

  placeSearchQuery = '';
  placePredictions: any[] = [];
  showPlaceSuggestions = false;
  isSearchingPlaces = false;
  isResolvingPlace = false;
  private addressResolvedFromSearch = false;
  private placeSearchDebounce: any;

  openMap(type: 'pickup' | 'drop') {
    this.mapType = type;
    this.mapMode = 'select';
    this.showMap = true;
    this.isMapLoading = true;
    this.placeSearchQuery = '';
    this.placePredictions = [];
    this.showPlaceSuggestions = false;
    this.addressResolvedFromSearch = false;

    setTimeout(() => {
      this.useCurrentLocation(type);
    }, 200);
  }

  openMapAt(lng: number, lat: number) {
    if (this.map) {
      this.map.remove();
      this.map = undefined as any;
    }
    this.initMap([lng, lat]);
    this.updateMarker(lng, lat);
    this.reverseGeocode(lng, lat);
    this.isMapLoading = false;
  }

  openMapOnUserCity() {
    const city = 'Harare';

    if (!city) {
      this.openMapAt(-17.825387, 31.0534);
      return;
    }

    fetch(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(city)}.json?access_token=${environment.mapboxToken}`,
    )
      .then((res) => res.json())
      .then((data) => {
        const center = data.features?.[0]?.center;
        center
          ? this.openMapAt(center[0], center[1])
          : this.openMapAt(-17.825387, 31.0534);
      })
      .catch(() => this.openMapAt(-17.825387, 31.0534));
  }

  closeMap() {
    this.showMap = false;
    this.mapLoaded = false;
    this.isMapLoading = false;

    if (this.marker) {
      this.marker.remove();
      this.marker = undefined as any;
    }

    if (this.map) {
      this.map.remove();
      this.map = undefined as any;
    }

    const container = document.getElementById('map');
    if (container) {
      container.innerHTML = '';
    }
  }

  initMap(center: [number, number]) {
    if (this.map) return;

    this.map = new mapboxgl.Map({
      container: 'map',
      style: 'mapbox://styles/mapbox/streets-v11',
      center,
      zoom: 12,
      accessToken: environment.mapboxToken,
    });

    this.map.addControl(new mapboxgl.NavigationControl(), 'top-right');

    this.map.once('load', () => {
      this.mapLoaded = true;
      this.isMapLoading = false;
      this.map.resize();

      this.map.setLayoutProperty('road-label', 'text-size', 14);

      this.map.setLayoutProperty('place-label', 'text-size', 16);
    });

    this.map.on('click', (e) => {
      const { lng, lat } = e.lngLat;
      this.showPlaceSuggestions = false;
      this.addressResolvedFromSearch = false;
      this.setMarker(lng, lat);
      this.reverseGeocode(lng, lat);
    });
  }

  onPlaceSearchInput(value: string) {
    this.placeSearchQuery = value;
    this.addressResolvedFromSearch = false;
    clearTimeout(this.placeSearchDebounce);

    const query = value.trim();
    if (query.length < 3) {
      this.placePredictions = [];
      this.showPlaceSuggestions = false;
      return;
    }

    this.placeSearchDebounce = setTimeout(
      () => this.fetchPlacePredictions(query),
      300,
    );
  }

  fetchPlacePredictions(query: string) {
    this.isSearchingPlaces = true;

    fetch('https://places.googleapis.com/v1/places:autocomplete', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Goog-Api-Key': environment.googleApiKey,
      },
      body: JSON.stringify({ input: query }),
    })
      .then((res) => res.json())
      .then((data) => {
        this.placePredictions = (data.suggestions || [])
          .map((s: any) => s.placePrediction)
          .filter(Boolean);
        this.showPlaceSuggestions = this.placePredictions.length > 0;
      })
      .catch(() => {
        this.placePredictions = [];
        this.showPlaceSuggestions = false;
      })
      .finally(() => {
        this.isSearchingPlaces = false;
      });
  }

  selectPlacePrediction(prediction: any) {
    if (!prediction?.placeId) return;

    this.showPlaceSuggestions = false;
    this.placeSearchQuery = prediction.text?.text || '';
    this.isResolvingPlace = true;

    fetch(`https://places.googleapis.com/v1/places/${prediction.placeId}`, {
      headers: {
        'X-Goog-Api-Key': environment.googleApiKey,
        'X-Goog-FieldMask': 'location,formattedAddress,addressComponents',
      },
    })
      .then((res) => res.json())
      .then((data) => {
        const lat = data?.location?.latitude;
        const lng = data?.location?.longitude;
        if (lat == null || lng == null) return;

        this.selectedAddress = data.formattedAddress || this.placeSearchQuery;
        this.addressResolvedFromSearch = true;

        const components = data.addressComponents || [];
        const addressDetails = {
          fullAddress: this.selectedAddress,
          pincode: this.getGoogleAddressComponent(components, 'postal_code'),
          locality: this.getGoogleAddressComponent(components, 'sublocality'),
          city: this.getGoogleAddressComponent(components, 'locality'),
          district: this.getGoogleAddressComponent(
            components,
            'administrative_area_level_2',
          ),
          state: this.getGoogleAddressComponent(
            components,
            'administrative_area_level_1',
          ),
          country: this.getGoogleAddressComponent(components, 'country'),
          latitude: lat,
          longitude: lng,
        };

        if (this.mapType === 'pickup') {
          this.pickupAddressDetails = addressDetails;
        } else {
          this.dropAddressDetails = addressDetails;
        }

        this.setMarker(lng, lat);
        this.map?.flyTo({ center: [lng, lat], zoom: 16 });
      })
      .finally(() => {
        this.isResolvingPlace = false;
      });
  }

  getGoogleAddressComponent(components: any[], type: string): string {
    return components.find((c) => c.types?.includes(type))?.longText || '';
  }

  reverseGeocode(lng: number, lat: number) {
    fetch(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json?access_token=${environment.mapboxToken}`,
    )
      .then((res) => res.json())
      .then((data) => {
        const feature = data.features?.[0];
        if (!feature) return;

        const context = feature.context || [];

        const addressDetails = {
          fullAddress: feature.place_name || '',
          pincode: this.getContextValue(context, 'postcode'),
          locality: this.getContextValue(context, 'locality'),
          city: this.getContextValue(context, 'place'),
          district: this.getContextValue(context, 'district'),
          state: this.getContextValue(context, 'region'),
          country: this.getContextValue(context, 'country'),
          latitude: lat,
          longitude: lng,
        };

        this.selectedAddress = addressDetails.fullAddress;

        if (this.mapType === 'pickup') {
          this.pickupAddressDetails = addressDetails;
        } else {
          this.dropAddressDetails = addressDetails;
        }
      });
  }

  getContextValue(context: any[], type: string): string {
    return context.find((c) => c.id.startsWith(type))?.text || '';
  }

  isFetchingAddress = false;

  getGoogleAddress(lat: number, lng: number): Promise<string> {
    return fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${environment.googleApiKey}`,
    )
      .then((res) => res.json())
      .then((data) => {
        if (data?.status === 'OK' && data.results?.length) {
          return this.pickBestGoogleAddress(data.results);
        }
        return '';
      })
      .catch(() => '');
  }

  private pickBestGoogleAddress(results: any[]): string {
    const hasType = (result: any, type: string) =>
      result.address_components?.some((c: any) => c.types?.includes(type));

    const properStreetAddress = results.find(
      (r) => hasType(r, 'street_number') && hasType(r, 'route'),
    );
    if (properStreetAddress) return properStreetAddress.formatted_address || '';

    const nonPlusCode = results.find(
      (r) => !/^[A-Z0-9]{4,}\+[A-Z0-9]{2,3}\b/.test(r.formatted_address || ''),
    );
    if (nonPlusCode) return nonPlusCode.formatted_address || '';

    return results[0].formatted_address || '';
  }

  updateMarker(lng: number, lat: number) {
    this.selectedLng = lng;
    this.selectedLat = lat;

    if (this.marker) {
      this.marker.remove();
    }

    this.marker = new mapboxgl.Marker({ color: 'red' })
      .setLngLat([lng, lat])
      .addTo(this.map);
  }

  setMarker(lng: number, lat: number) {
    if (this.marker) this.marker.remove();

    this.marker = new mapboxgl.Marker({ color: '#e53935' })
      .setLngLat([lng, lat])
      .addTo(this.map);

    this.selectedLng = lng;
    this.selectedLat = lat;
  }

  useCurrentLocation(type: 'pickup' | 'drop') {
    this.mapType = type;
    let locationResolved = false;

    const watchId = navigator.geolocation.watchPosition(
      (pos) => {
        if (locationResolved) return;
        locationResolved = true;

        navigator.geolocation.clearWatch(watchId);

        const lng = pos.coords.longitude;
        const lat = pos.coords.latitude;

        this.openMapAt(lng, lat);
      },
      () => {},
      {
        enableHighAccuracy: false,
        maximumAge: 10000,
      },
    );

    setTimeout(() => {
      if (!locationResolved) {
        navigator.geolocation.clearWatch(watchId);
        this.openMapOnUserCity();
      }
    }, 8000);
  }

  confirmLocation() {
    if (!this.marker) return;

    const address =
      this.mapType === 'pickup'
        ? this.pickupAddressDetails
        : this.dropAddressDetails;

    if (!address) return;

    const applyToForm = () => {
      if (this.mapType === 'pickup') {
        this.ambulanceForm.patchValue({
          pick_lat: this.selectedLat,
          pick_lng: this.selectedLng,
          pickLocation: this.selectedAddress,
        });
      } else {
        this.ambulanceForm.patchValue({
          drop_lat: this.selectedLat,
          drop_lng: this.selectedLng,
          dropLocation: this.selectedAddress,
        });
      }

      this.isFetchingAddress = false;
      this.showMap = false;
    };

    if (this.addressResolvedFromSearch) {
      applyToForm();
      return;
    }

    this.isFetchingAddress = true;

    this.getGoogleAddress(this.selectedLat, this.selectedLng)
      .then((googleAddress) => {
        if (googleAddress) {
          this.selectedAddress = googleAddress;
          address.fullAddress = googleAddress;
        }
      })
      .finally(applyToForm);
  }

  initRouteMap() {
    const pickup: [number, number] = [
      this.ambulanceForm.value.pick_lng,
      this.ambulanceForm.value.pick_lat,
    ];

    const drop: [number, number] = [
      this.ambulanceForm.value.drop_lng,
      this.ambulanceForm.value.drop_lat,
    ];

    this.map = new mapboxgl.Map({
      container: 'map',
      style: 'mapbox://styles/mapbox/navigation-day-v1',
      center: pickup,
      zoom: 12,
      accessToken: environment.mapboxToken,
    });

    new mapboxgl.Marker({ color: 'green' }).setLngLat(pickup).addTo(this.map);
    new mapboxgl.Marker({ color: 'red' }).setLngLat(drop).addTo(this.map);

    this.loadRouteFromBackend();
  }

  loadRouteFromBackend() {
    const { pick_lat, pick_lng, drop_lat, drop_lng } = this.ambulanceForm.value;

    this.apiService
      .getAmbulanceEndpoints({
        sourceLat: pick_lat,
        sourceLng: pick_lng,
        destLat: drop_lat,
        destLng: drop_lng,
      })
      .subscribe((res: any) => {
        if (!res.success || !res.routes?.length) return;

        this.clearRoutes();

        if (res.routes?.length) {
          this.drawRoute(res.routes[0], 0, true);
        }

        this.routeDistance = `${res.routes[0].distance_km} km`;
        this.routeDuration = `${res.routes[0].duration_min} min`;
      });
  }

  drawRoute(route: any, index: number, isPrimary = false) {
    const coords: [number, number][] = route.geometry.coordinates;

    const sourceId = `route-${index}`;
    const layerId = `route-layer-${index}`;

    this.map.addSource(sourceId, {
      type: 'geojson',
      data: {
        type: 'Feature',
        geometry: {
          type: 'LineString',
          coordinates: coords,
        },
        properties: {},
      },
    });

    this.map.addLayer({
      id: layerId,
      type: 'line',
      source: sourceId,
      paint: {
        'line-color': isPrimary ? '#1f8ae8' : '#e95fd0',
        'line-width': isPrimary ? 8 : 8,
        'line-opacity': isPrimary ? 1 : 0.5,
      },
    });

    if (isPrimary) {
      this.fitBounds(coords);
      this.addRouteLabel(coords, route);
    }
  }

  fitBounds(coordinates: [number, number][]) {
    const bounds = new mapboxgl.LngLatBounds();

    coordinates.forEach((coord) => bounds.extend(coord));

    this.map.fitBounds(bounds, { padding: 60 });
  }

  addRouteLabel(coords: [number, number][], route: any) {
    const midIndex = Math.floor(coords.length / 2);

    new mapboxgl.Popup({ closeOnClick: false })
      .setLngLat(coords[midIndex])
      .setHTML(
        `
        <strong>${route.distance_km} km</strong><br/>
        ⏱ ${route.duration_min} min
      `,
      )
      .addTo(this.map);
  }

  clearRoutes() {
    const style = this.map.getStyle();
    if (!style?.layers) return;

    style.layers
      .filter((l) => l.id.startsWith('route-layer-'))
      .forEach((l) => this.map.removeLayer(l.id));

    Object.keys(this.map.getStyle().sources)
      .filter((id) => id.startsWith('route-'))
      .forEach((id) => this.map.removeSource(id));
  }

  // map end

  ngOnInit() {
    this.bsDatepickerConfig = {
      showWeekNumbers: false,
      minDate: new Date(),
      maxDate: this.commonService.getSevenDayOrMonthEnd(),
      dateInputFormat: 'YYYY-MM-DD',
    };

    this.medicalbsDatepickerConfig = {
      showWeekNumbers: false,
      maxDate: new Date(),
      dateInputFormat: 'YYYY-MM-DD',
      adaptivePosition: true,
      returnFocusToInput: true,
      selectFromOtherMonth: true,
    };
    this.isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      );
    this.commonService.addmodelAmbulanceClosed$.subscribe((ele: any) => {
      if (ele) {
        this.getAllPatient('');
        this.ambulanceForm.reset();
        this.ambulanceForm.get('gender')?.setValue('');
        this.ambulanceForm.get('age')?.enable();
        this.ambulanceForm.get('gender')?.enable();
        this.ambulanceForm.get('phone')?.disable();
        this.ambulancePatientHasPhone = true;
      }
    });
    this.commonService.addmodalClosed$.subscribe((ele: any) => {
      if (ele) {
        this.getAllPatient('');
        this.getUserUnlockMedicalRecord();
        if (
          !this.telResFormData ||
          Object.keys(this.telResFormData).length === 0
        ) {
          this.teleMedicineConsultForm.reset();
          this.teleMedicineConsultForm.get('gender')?.setValue('');
          this.teleMedicineConsultForm.get('age')?.enable();
          this.teleMedicineConsultForm.get('gender')?.enable();
          this.teleMedicineConsultForm.get('phone')?.disable();
          this.telemediPatientHasPhone = true;
        }
      }
    });

    this.commonService.addMmodalClosed$.subscribe((ele: any) => {
      if (ele) {
        this.getAllPatient('');
        this.getAllMedicalRecordTypes();
        this.medicalForm.reset();
        this.medicalForm.get('patient')?.setValue('');
        this.medicalForm.get('report_type_id')?.setValue('');
        // this.medicalForm.get('is_lock')?.setValue(true);
        this.medicalForm.get('privacy_setting')?.setValue('Only Me');
        this.fileInput2.nativeElement.value = '';
        this.uploadedFile = '';
        this.uploadedFileName = '';
        this.showDescription = false;
      }
    });
    this.myDateValue = new Date();

    this.medicalForm = this.fb.group({
      patient: ['', Validators.required],
      description: [''],
      hospital: ['', Validators.required],
      report_name: ['', Validators.required],
      symptoms: ['', Validators.required],
      treatmentDate: ['', [Validators.required]],
      userFile: [null, Validators.required],
      report_type_id: ['', Validators.required],
      report_type_description: [null],
      // is_lock: [true, Validators.required],
      privacy_setting: ['Only Me', Validators.required],
    });
    this.ambulanceForm = this.fb.group({
      patient: [null, Validators.required],
      age: [null, [Validators.required, Validators.min(18)]],
      gender: ['', Validators.required],
      phone: [null, [Validators.required, this.zimbabweMobileValidator()]],
      medicalReason: ['', Validators.required],
      pickLocation: ['', Validators.required],
      dropLocation: ['', Validators.required],
      pick_lat: [null, Validators.required],
      pick_lng: [null, Validators.required],
      buildingPickLocation: ['', Validators.maxLength(100)],
      drop_lat: [null, Validators.required],
      drop_lng: [null, Validators.required],
      buildingDropLocation: ['', Validators.maxLength(100)],
    });

    this.ambulanceForm.get('phone')?.disable();

    this.EditambulanceForm = this.fb.group({
      patient: ['', Validators.required],
      age: [null, [Validators.required, Validators.min(18)]],
      gender: ['', Validators.required],
      phone: [null, [Validators.required, this.zimbabweMobileValidator()]],
      medicalReason: [''],
      pickLocation: ['', Validators.required],
      dropLocation: ['', Validators.required],
    });
    this.teleMedicineConsultForm = this.fb.group({
      slot_id: [null, Validators.required],
      consultation_type: ['', Validators.required],
      patient: [null, Validators.required],
      currency: [''],
      a_la_carte_price: [null],
      age: [null, [Validators.required, Validators.min(18)]],
      gender: [null, Validators.required],
      reason_for_consultation: [null, Validators.required],
      country_dial_code: ['', Validators.required],
      phone: [null, [Validators.required, this.zimbabweMobileValidator()]],
      appointment_date: ['', Validators.required],
      plan_consultation: ['', Validators.required],
      medical_report_id: [[]],
    });
    this.teleMedicineConsultForm.get('phone')?.disable();

    this.commonService.editData$1.subscribe((data) => {
      if (data) {
        this.ambulanceUpdateData = data;
        const p = this.patientList.find((x: any) => x.user_id === data.user_id);
        const birthDate = p?.dob ? new Date(p.dob) : null;
        const age = birthDate
          ? new Date().getFullYear() -
            birthDate.getFullYear() -
            (new Date() <
            new Date(
              new Date().getFullYear(),
              birthDate.getMonth(),
              birthDate.getDate(),
            )
              ? 1
              : 0)
          : null;
        const gender = p?.gender ? p.gender.toLowerCase() : null;
        this.EditambulanceForm.patchValue({
          patient: p,
          age,
          gender,
          phone: p?.phone,
          medicalReason: data.medical_condition,
          pickLocation: data.pickup_location,
          dropLocation: data.dropoff_location,
        });

        Object.keys(this.EditambulanceForm.controls).forEach((key) => {
          if (key !== 'phone') this.EditambulanceForm.get(key)?.disable();
        });
      }
    });

    this.teleMedicineConsultForm
      .get('plan_consultation')
      ?.valueChanges.subscribe((value: any) => {
        const appointmentCtrl =
          this.teleMedicineConsultForm.get('appointment_date');
        const slotCtrl = this.teleMedicineConsultForm.get('slot_id');

        appointmentCtrl?.clearValidators();
        slotCtrl?.clearValidators();
        appointmentCtrl?.setValue(null);
        slotCtrl?.setValue(null);

        if (value === 'Consult Now') {
          appointmentCtrl?.disable();
          slotCtrl?.disable();
        } else {
          appointmentCtrl?.enable();
          slotCtrl?.enable();

          const currentDate = appointmentCtrl?.value;
          if (currentDate) {
            this.getSlotsData(currentDate);
          }
        }

        appointmentCtrl?.updateValueAndValidity();
        slotCtrl?.updateValueAndValidity();
      });

    this.commonService.modalData$.subscribe((data) => {
      this.isFieldDisabled = false;
      this.enableAllFormFields();

      if (data) {
        if (data?.pdfUrl) {
          this.pdfUrl = data?.pdfUrl;
        } else {
          this.isReschedule = false;
          this.alaCartPriceOption = data?.alaCarteService;
          this.telResFormData = data?.formData;
          this.teleSubsCounts();

          if (!data?.formData || Object.keys(data.formData).length === 0) {
            this.telResFormData = {};
            this.currencyPrice = 0;
            this.teleMedicineConsultForm.get('consultation_type')?.enable();
            this.teleMedicineConsultForm.get('patient')?.enable();
            this.teleMedicineConsultForm.get('age')?.enable();
            this.teleMedicineConsultForm.get('gender')?.enable();
            this.teleMedicineConsultForm
              .get('reason_for_consultation')
              ?.enable();
            this.teleMedicineConsultForm.get('country_dial_code')?.enable();
            this.teleMedicineConsultForm.get('plan_consultation')?.enable();
            this.teleMedicineConsultForm.get('currency')?.enable();
            this.teleMedicineConsultForm.get('a_la_carte_price')?.enable();
          } else {
            this.isReschedule = data?.backBtnInitiated ? false : true;
            this.isUpdated = data?.backBtnInitiated || false;

            this.apiService.getDependent().subscribe((res: any) => {
              let allPatients = res.data || [];
              if (allPatients.length === 0) {
                allPatients = this.buildLocalStoragePatient();
              }
              this.patientList = allPatients;
              const selectedPatient = this.patientList.find(
                (x: any) => x?.user_id === this.telResFormData?.user_id,
              );
              let dob = selectedPatient?.dob;
              let age = null;
              let gender = selectedPatient.gender
                ? selectedPatient.gender?.toLowerCase()
                : '';
              if (dob) {
                const d = new Date(dob),
                  t = new Date();
                age = t.getFullYear() - d.getFullYear();
                if (
                  t.getMonth() < d.getMonth() ||
                  (t.getMonth() === d.getMonth() && t.getDate() < d.getDate())
                )
                  age--;
              }

              this.addedMedicalDetails =
                this.isUpdated || this.isReschedule
                  ? (this.telResFormData?.medical || []).map((el: any) => {
                      return {
                        id: el?.id,
                        type:
                          el?.type === 'MEDICAL'
                            ? 'medical_record'
                            : el?.type?.toLowerCase(),
                      };
                    })
                  : [];

              this.teleMedicineConsultForm.patchValue({
                consultation_type: this.telResFormData.consultation_type,
                patient: selectedPatient,
                age: age,
                gender: gender,
                reason_for_consultation:
                  this.telResFormData.reason_for_consultation == 'IVR' ||
                  this.telResFormData.reason_for_consultation == 'USSD' ||
                  this.telResFormData.reason_for_consultation == 'N/A'
                    ? null
                    : this.telResFormData.reason_for_consultation,
                country_dial_code: this.telResFormData.country_dial_code,
                phone: this.telResFormData.phone_number,
                plan_consultation:
                  this.telResFormData?.tc_plan_type || 'Scheduled',
                slot_id:
                  this.isUpdated &&
                  this.telResFormData?.slot_id &&
                  this.telResFormData?.slot_id !== 'N/A'
                    ? this.telResFormData?.slot_id
                    : null,
                appointment_date:
                  this.isUpdated &&
                  this.telResFormData?.booking_date &&
                  this.telResFormData?.booking_date !== 'N/A'
                    ? new Date(this.telResFormData?.booking_date)
                    : null,
                medical_report_id: this.addedMedicalDetails,
              });

              if (
                this.telResFormData.is_al_carte === 1 ||
                this.telResFormData.is_al_carte
              ) {
                this.alaCartPriceOption = false;
                this.currencyPrice = this.telResFormData?.a_la_carte_price ?? 0;
                this.teleMedicineConsultForm.patchValue({
                  currency: this.telResFormData?.currency,
                  a_la_carte_price: this.telResFormData.a_la_carte_price,
                });
                if (this.isReschedule) {
                  this.teleMedicineConsultForm.get('currency')?.disable();
                  this.teleMedicineConsultForm
                    .get('a_la_carte_price')
                    ?.disable();
                }
              } else {
                this.currencyPrice = 0;
                this.alaCartPriceOption = true;
              }

              const status = this.telResFormData?.tc_booking_status;
              const payment_status = this.telResFormData?.payment_status;

              if (this.isUpdated && status === 'IN PROGRESS') {
                this.isFieldDisabled = true;
                Object.keys(this.teleMedicineConsultForm.controls).forEach(
                  (key) => {
                    if (key !== 'medical_report_id' && key !== 'slot_id') {
                      this.teleMedicineConsultForm.get(key)?.disable();
                    } else {
                      this.teleMedicineConsultForm.get(key)?.enable();
                    }
                  },
                );
              } else if (
                this.isUpdated &&
                status === 'REQUEST' &&
                payment_status == 'Success'
              ) {
                Object.keys(this.teleMedicineConsultForm.controls).forEach(
                  (key) => {
                    if (key !== 'phone') {
                      this.teleMedicineConsultForm.get(key)?.enable();
                    }
                  },
                );

                this.teleMedicineConsultForm.get('currency')?.disable();
                this.teleMedicineConsultForm.get('a_la_carte_price')?.disable();
              } else {
                this.enableAllFormFields();
              }

              if (this.isReschedule) {
                if (!this.alaCartPriceOption) {
                  this.teleMedicineConsultForm.get('currency')?.disable();
                  this.teleMedicineConsultForm
                    .get('a_la_carte_price')
                    ?.disable();
                }
                const isConsultNow =
                  this.telResFormData?.tc_plan_type === 'Consult Now';
                [
                  'consultation_type',
                  'patient',
                  'age',
                  'gender',
                  'reason_for_consultation',
                  'country_dial_code',
                  'phone',
                  ...(isConsultNow ? [] : ['plan_consultation']),
                ].forEach((field) => {
                  const control = this.teleMedicineConsultForm.get(field);
                  if (
                    control &&
                    control.value !== null &&
                    control.value !== ''
                  ) {
                    control.disable();
                  }
                });
              }

              if (this.isUpdated) {
                ['patient', 'age', 'gender'].forEach((field) => {
                  const control = this.teleMedicineConsultForm.get(field);
                  if (control) {
                    control.disable({ emitEvent: false });
                  }
                });
              }
            });
            // this.teleMedicineConsultForm.reset();
          }
        }
      }
    });

    [
      'buildingPickLocation',
      'pickLocation',
      'buildingDropLocation',
      'dropLocation',
    ].forEach((field) => {
      this.ambulanceForm.get(field)?.valueChanges.subscribe(() => {
        this.ambulanceForm.updateValueAndValidity({ emitEvent: false });
      });
    });

    setTimeout(() => {
      this.teleMedicineConsultForm
        .get('plan_consultation')
        ?.updateValueAndValidity({ emitEvent: true });
    }, 0);

    this.commonService.appointment$.subscribe((data) => {
      this.selectedAppointment = data;
      console.log('Received appointment data:', this.selectedAppointment);
    });

    this.commonService.ratingQA$.subscribe((data) => {
      this.ratingQuesAns = data;
      console.log('Received ratingQuesAns data:', this.ratingQuesAns);
    });
  }

  enableAllFormFields() {
    Object.keys(this.teleMedicineConsultForm.controls).forEach((key) => {
      if (key !== 'phone') {
        this.teleMedicineConsultForm.get(key)?.enable();
      }
    });
  }

  comparePatients(patient1: any, patient2: any): boolean {
    if (!patient1 && !patient2) return true; // both null
    if (!patient1 || !patient2) return false; // one is null
    return patient1.user_id === patient2.user_id;
  }

  getCurrencyPrice() {
    const form2 = this.teleMedicineConsultForm;
    const currency = form2.get('currency')?.value;
    const payload = {
      currency: currency,
      feature_name: 'Telemedicine Consultations',
    };
    this.apiService.getAlacartePrice(payload).subscribe((res: any) => {
      let a_la_carte_price = res.data.a_la_carte_price;
      form2.get('a_la_carte_price')?.disable();
      form2.patchValue({ a_la_carte_price: a_la_carte_price });
      this.currencyPrice = res.data.a_la_carte_price;
    });
  }

  dobNotInFutureValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const dob = new Date(control.value);
      const today = new Date();
      if (control.value && dob > today) {
        return { futureDate: true };
      }
      return null;
    };
  }

  private buildLocalStoragePatient(): any[] {
    const user = JSON.parse(localStorage.getItem('pat_user') || '{}');
    if (!user?.user_id) return [];
    return [
      {
        user_id: user.user_id,
        first_name: user.first_name || '',
        last_name: user.last_name || '',
        phone: user.phone || '',
        dob: user.dob || null,
        gender: user.gender || '',
        is_logged_in_user: true,
      },
    ];
  }

  getAllPatient(text: any) {
    let token = localStorage.getItem('pat_authToken');
    if (token) {
      this.apiService.getDependent().subscribe((res: any) => {
        let allPatients = res.data || [];
        if (allPatients.length === 0) {
          allPatients = this.buildLocalStoragePatient();
        }
        const user = JSON.parse(localStorage.getItem('pat_user') || '{}');
        if (text === 'medical' && user.role === 'Dependent') {
          this.patientList = allPatients.filter(
            (patient: any) => patient.user_id === user.user_id,
          );
        } else {
          this.patientList = allPatients;
        }
      });
    }
  }

  zimbabweMobileValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let value = control?.value;
      if (!value) return { invalidZimbabweMobile: true };
      if (typeof value === 'object' && value.nationalNumber) {
        value = value.nationalNumber;
      }
      if (typeof value !== 'string') return { invalidZimbabweMobile: true };
      value = value.replace(/\s+/g, ''); // Remove whitespace
      value = value.startsWith('0') ? value.substring(1) : value;
      const zimbabweMobileRegex = /^\d{9}$/;
      return zimbabweMobileRegex.test(value)
        ? null
        : { invalidZimbabweMobile: true };
    };
  }

  onPhoneInput(event: any): void {
    const input = event.target.value;
    const cleanedValue = input.replace(/\D/g, '');
    event.target.value = cleanedValue;
  }

  teleSubsCounts() {
    if (this.alaCartPriceOption) {
      const user = JSON.parse(localStorage.getItem('pat_user') || '');
      this.apiService.getSubTelemedCount(user?.user_id).subscribe(
        (res: any) => {
          this.subTelemedCount = res?.data?.length || 0;
          if (this.subTelemedCount >= 12) {
            this.completeTelemedSub = true;
          }
        },
        (err: any) => {
          this.subTelemedCount = 0;
        },
      );
    }
  }

  onSubmitMedicalRecords() {
    if (this.medicalForm.valid) {
      this.spinner.show();
      const formData1 = new FormData();

      formData1.append('date', this.medicalForm.value.treatmentDate);
      formData1.append('hospital_name', this.medicalForm.value.hospital);
      formData1.append('report_name', this.medicalForm.value.report_name);
      formData1.append('report', this.uploadedFile);
      formData1.append('symptoms', this.medicalForm.value.symptoms);
      formData1.append('patient_id', this.medicalForm.value.patient);
      formData1.append('description', this.medicalForm.value.description);
      formData1.append(
        'report_type_id',
        this.medicalForm.value.report_type_id.id,
      );
      formData1.append(
        'report_type_description',
        this.medicalForm.value.report_type_description || null,
      );
      // formData1.append('is_lock', this.medicalForm.value.is_lock ? '1' : '0');
      formData1.append(
        'privacy_setting',
        this.medicalForm.value.privacy_setting,
      );

      this.apiService.addMedicalRecords(formData1).subscribe(
        (res: any) => {
          this.tosterService.success('Medical records added successfully', '', {
            timeOut: 4000,
          });
          this.spinner.hide();
          this.medicalForm.reset();
          this.uploadedFile = null;
          this.uploadedFileName = '';
          this.medicalForm.get('patient')?.setValue('');
          this.medicalForm.get('report_type_id')?.setValue('');

          if (this.birthdatepicker) {
            this.birthdatepicker.bsValue = null;
          }
          (
            document.getElementById('closeMedicalModalBtn') as HTMLElement
          )?.click();
          this.commonService.emitModalClosed();
        },
        (err) => {
          this.tosterService.error('Failed to add medical record.', '', {
            timeOut: 4000,
          });
          console.error('Error adding Medical record:', err);
          this.spinner.hide();
        },
      );
    } else {
      this.medicalForm.markAllAsTouched();
    }
  }

  onFileChange(event: any): void {
    const file = event.target.files[0];
    if (!file) return;

    const validTypes = [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'image/png',
      'image/jpeg',
      'image/jpg',
    ];

    const allowedExtensions = ['pdf', 'doc', 'docx', 'png', 'jpg', 'jpeg'];
    const fileExtension = file.name.split('.').pop()?.toLowerCase();

    if (
      !validTypes.includes(file.type) ||
      !allowedExtensions.includes(fileExtension || '')
    ) {
      alert(
        'Please select a valid PDF, Word document, or Image (PNG/JPG/JPEG).',
      );
      this.uploadedFile = null;
      this.uploadedFileName = '';
      this.medicalForm.patchValue({ userFile: null });
      return;
    }

    this.uploadedFile = file;
    this.uploadedFileName = file.name;
    this.medicalForm.patchValue({ userFile: file });
  }

  proceed() {
    if (this.ambulanceForm.invalid) {
      this.ambulanceForm.markAllAsTouched();
      return;
    }

    this.mapMode = 'route';
    this.showMap = true;

    setTimeout(() => this.initRouteMap(), 0);
  }

  onBookingAmbulance(): void {
    this.spinner.show();
    this.showMap = false;
    const formValue = this.ambulanceForm.getRawValue();

    if (
      !formValue.patient?.user_id ||
      !formValue.pickLocation ||
      !formValue.dropLocation ||
      !formValue.pick_lat ||
      !formValue.pick_lng ||
      !formValue.drop_lat ||
      !formValue.drop_lng ||
      (!this.ambulancePatientHasPhone ? false : !formValue.phone?.number) ||
      this.ambulanceForm.get('age')?.invalid ||
      (!this.ambulancePatientHasPhone
        ? false
        : formValue.phone?.number?.replace(/\s/g, '').length !== 9) ||
      (!this.ambulancePatientHasPhone ? false : !formValue.phone?.dialCode)
    ) {
      this.ambulanceForm.markAllAsTouched();
      this.spinner.hide();
      return;
    }
    const payload: any = {
      user_id: formValue.patient?.user_id,
      phone_number:
        this.ambulancePatientHasPhone && formValue.phone?.number
          ? formValue.phone.number.replace(/\s/g, '')
          : '',
      country_dial_code: this.ambulancePatientHasPhone
        ? formValue.phone?.dialCode
        : '',
      medical_condition: formValue.medicalReason || '',
      pickup_location: formValue.pickLocation || '',
      dropoff_location: formValue.dropLocation || '',
      pickup_lat: formValue.pick_lat || 0,
      pickup_lng: formValue.pick_lng || 0,
      dropoff_lat: formValue.drop_lat || 0,
      dropoff_lng: formValue.drop_lng || 0,
      pick_country: this.pickupAddressDetails?.country || '',
      pick_state: this.pickupAddressDetails?.state || '',
      pick_city: this.pickupAddressDetails?.city || '',
      drop_country: this.dropAddressDetails?.country || '',
      drop_state: this.dropAddressDetails?.state || '',
      drop_city: this.dropAddressDetails?.city || '',
      building_pick_location: formValue.buildingPickLocation || null,
      building_drop_location: formValue.buildingDropLocation || null,
      is_al_carte:
        localStorage.getItem('consult_status') == 'false' ? true : false,
      channel_id: 1,
    };

    this.apiService.bookAmbulance(payload).subscribe(
      (res: any) => {
        if (res?.success) {
          this.tosterService.success('Ambulance booked successfully', '', {
            timeOut: 4000,
          });
          this.spinner.hide();
          const oldStatus = 'Null';
          const newStatus = 'NEW';
          const bookingData = res?.data;

          this.bookingLogService
            .logBookingAction(oldStatus, newStatus, bookingData, 'ambulance')
            .subscribe(
              (response) => {
                this.spinner.hide();
              },
              (error) => {
                this.spinner.hide();
                this.tosterService.error(
                  error.error.message ||
                    error.error.error ||
                    'An error occurred',
                );
              },
            );
          (document.getElementById('book') as HTMLElement)?.click();
          this.commonService.emitModalClosed();
          this.ambulanceForm.reset();
        } else {
          this.tosterService.error('Failed to book ambulance.', '', {
            timeOut: 4000,
          });
        }
      },
      (err) => {
        this.spinner.hide();
        this.tosterService.error('Failed to book ambulance.', '', {
          timeOut: 4000,
        });
        console.error('Error book Ambulance:', err);
      },
    );
  }

  onEditBooking(): void {
    this.spinner.show();
    const formValue = this.EditambulanceForm.getRawValue();
    if (
      !formValue.phone ||
      !formValue.phone.number ||
      formValue.phone.number.replace(/\s/g, '').length !== 9 ||
      !formValue.phone.dialCode
    ) {
      this.EditambulanceForm.markAllAsTouched();
      this.spinner.hide();
      return;
    }
    const payload: any = {
      medical_condition: formValue.medicalReason || '',
      pickup_location: formValue.pickLocation || '',
      dropoff_location: formValue.dropLocation || '',
      phone_number: formValue.phone?.number?.replace(/\s/g, '') || '',
      country_dial_code: formValue.phone.dialCode,
    };
    this.apiService
      .editAmbulance(this.ambulanceUpdateData.ambulance_booking_id, payload)
      .subscribe(
        (res) => {
          this.tosterService.success('Ambulance updated successfully', '', {
            timeOut: 4000,
          });
          this.spinner.hide();
          (document.getElementById('updated') as HTMLElement)?.click();
          this.commonService.emitModalClosed();
          this.EditambulanceForm.reset();
        },
        (err) => {
          this.spinner.hide();
          this.tosterService.error('Failed to updated Ambulance.', '', {
            timeOut: 4000,
          });
          console.error('Error updated Ambulance:', err);
        },
      );
  }

  cleanInput(event: KeyboardEvent) {
    const key = event.key;
    const input = event.target as HTMLInputElement;
    const value = input.value;

    const isLetter = /^[a-zA-Z]$/.test(key);
    const isSpace = key === ' ';
    const isControlKey = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
    ].includes(key);

    if (
      !isLetter &&
      !(isSpace && value.length > 0 && !value.endsWith(' ')) &&
      !isControlKey
    ) {
      event.preventDefault();
    }
  }

  onPatientChange(text: any) {
    const form = this.ambulanceForm;
    const form2 = this.teleMedicineConsultForm;

    if (text === 'telemedi') {
      const patient = form2.get('patient')?.value;
      if (!patient) return;

      const { gender, dob, phone } = patient;
      let age: number | null = null;

      if (dob) {
        const birthDate = new Date(dob);
        const today = new Date();
        age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
      }

      if (gender) {
        form2.patchValue({ gender: gender.toLowerCase() });
        form2.get('gender')?.disable();
      }

      if (age !== null) {
        form2.patchValue({ age });
        form2.get('age')?.disable();
      }

      if (phone) {
        this.telemediPatientHasPhone = true;
        form2
          .get('phone')
          ?.setValidators([
            Validators.required,
            this.zimbabweMobileValidator(),
          ]);
        form2.patchValue({ phone });
      } else {
        this.telemediPatientHasPhone = false;
        form2.get('phone')?.clearValidators();
        form2.get('phone')?.setValue(null);
      }
      form2.get('phone')?.disable();
      form2.get('phone')?.updateValueAndValidity();
    } else {
      const patient = form.get('patient')?.value;
      if (!patient) return;

      const { gender, dob, phone } = patient;
      let age: number | null = null;

      if (dob) {
        const birthDate = new Date(dob);
        const today = new Date();
        age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
      }
      if (gender) {
        form.patchValue({ gender: gender.toLowerCase() });
        form.get('gender')?.disable();
      }
      if (age !== null) {
        form.patchValue({ age });
        form.get('age')?.disable();
      }

      if (phone) {
        this.ambulancePatientHasPhone = true;
        form
          .get('phone')
          ?.setValidators([
            Validators.required,
            this.zimbabweMobileValidator(),
          ]);
        form.patchValue({ phone });
      } else {
        this.ambulancePatientHasPhone = false;
        form.get('phone')?.clearValidators();
        form.get('phone')?.setValue(null);
      }
      form.get('phone')?.disable();
      form.get('phone')?.updateValueAndValidity();
    }
  }

  validateAge(type: any) {
    let ageControl;
    if (type == 'consultation') {
      ageControl = this.teleMedicineConsultForm.get('age');
    } else {
      ageControl = this.ambulanceForm.get('age');
    }

    if (ageControl) {
      const value = ageControl.value;
      if (value === null || value === '') {
        return;
      }
      if (value <= 0) {
        ageControl.setValue(1, { emitEvent: false });
      }
    }
  }

  blockInvalidKeys(event: KeyboardEvent) {
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }

  blockInvalidPaste(event: ClipboardEvent) {
    const pastedInput: string = event.clipboardData?.getData('text') || '';
    if (!/^\d+$/.test(pastedInput)) {
      event.preventDefault();
    }
  }

  updateAlaCarteValidators() {
    const currencyControl = this.teleMedicineConsultForm.get('currency');
    const priceControl = this.teleMedicineConsultForm.get('a_la_carte_price');

    if (this.alaCartPriceOption === false) {
      currencyControl?.setValidators([Validators.required]);
      priceControl?.setValidators([Validators.required]);
    } else {
      currencyControl?.clearValidators();
      priceControl?.clearValidators();
    }

    currencyControl?.updateValueAndValidity();
    priceControl?.updateValueAndValidity();
  }

  get ageCtrl() {
    return this.ambulanceForm.get('age');
  }

  onBookingTelemedicineConsultant(): void {
    this.spinner.show();
    const formValue = this.teleMedicineConsultForm.getRawValue();
    const isInProgress =
      this.telResFormData?.tc_booking_status === 'IN PROGRESS';

    if (
      !formValue.patient?.user_id ||
      !formValue.consultation_type ||
      (!formValue.reason_for_consultation && !isInProgress) ||
      (!formValue.plan_consultation && !isInProgress) ||
      (!this.telemediPatientHasPhone ? false : !formValue.phone?.number) ||
      (formValue.plan_consultation === 'Scheduled' &&
        !formValue?.slot_id &&
        !isInProgress) ||
      (formValue.plan_consultation === 'Scheduled' &&
        !formValue?.appointment_date &&
        !isInProgress) ||
      (!formValue.currency && !this.alaCartPriceOption) ||
      this.teleMedicineConsultForm.get('age')?.invalid ||
      (!this.telemediPatientHasPhone
        ? false
        : formValue.phone?.number &&
          formValue.phone?.number?.toString().replace(/\s/g, '').length !==
            9) ||
      (!this.telemediPatientHasPhone ? false : !formValue.phone?.dialCode)
    ) {
      this.updateAlaCarteValidators();
      this.teleMedicineConsultForm.markAllAsTouched();
      this.spinner.hide();
      return;
    }

    const payload: any = {
      slot_id:
        formValue.plan_consultation === 'Consult Now'
          ? null
          : formValue.slot_id,

      appointment_date:
        this.teleMedicineConsultForm.value.plan_consultation === 'Consult Now'
          ? null
          : this.teleMedicineConsultForm.value.appointment_date,

      consultation_type: formValue.consultation_type,
      user_id: formValue.patient.user_id,
      reason_for_consultation: formValue.reason_for_consultation,
      tc_plan_type: formValue.plan_consultation,
      country_dial_code: this.telemediPatientHasPhone
        ? formValue.phone?.dialCode
        : null,
      currency: formValue.currency,
      a_la_carte_price: formValue.a_la_carte_price,
      phone_number:
        this.telemediPatientHasPhone && formValue?.phone?.number
          ? Number(String(formValue.phone.number).replace(/\s/g, ''))
          : null,
      is_al_carte:
        localStorage.getItem('consult_status') == 'false' ? true : false,
      channel_id: 1,
      medical_report_id: formValue?.medical_report_id,
    };

    if (
      localStorage.getItem('consult_status') == 'true' &&
      this.subTelemedCount >= 12
    ) {
      payload.is_al_carte = true;
    }

    if (this.telResFormData && Object.keys(this.telResFormData).length > 0) {
      if (this.isUpdated) {
        if (!isInProgress) {
          this.apiService
            .updateTelemedicineConsultant(
              payload,
              this.telResFormData.tc_booking_id,
            )
            .subscribe(
              (res: any) => {
                if (res?.success) {
                  const sessionData = {
                    data: JSON.stringify(res),
                    expiry: new Date().getTime() + 5 * 60 * 1000,
                  };
                  sessionStorage.setItem(
                    'tele_consult_status',
                    JSON.stringify(sessionData),
                  );
                  this.tosterService.success(
                    'Telemedicine updated successfully',
                    '',
                    { timeOut: 4000 },
                  );

                  this.updateMedicalRecordsIfExists(
                    res.data.tc_booking_id,
                    payload.medical_report_id,
                    res.data.user_id,
                  );

                  this.teleMedicineConsultForm.reset();

                  if (this.datepicker) {
                    this.datepicker.bsValue = null;
                  }
                  (
                    document.getElementById('telemodel') as HTMLElement
                  )?.click();
                  setTimeout(() => {
                    this.commonService.emitModalClosed();
                  }, 0);
                  this.commonService.triggerRefreshParentDetail('consultation');
                  this.spinner.hide();
                } else {
                  this.spinner.hide();
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                  this.tosterService.error(
                    res?.message || 'Failed to update telemedicine consultant.',
                    '',
                    {
                      timeOut: 4000,
                    },
                  );
                }
              },
              (err) => {
                this.spinner.hide();
                this.tosterService.error(
                  'Failed to telemedicine consultant.',
                  '',
                  {
                    timeOut: 4000,
                  },
                );
                console.error('Error telemedicine consultant:', err);
              },
              () => {
                this.spinner.hide();
                this.isSubmittingtelemedi = false;
              },
            );
        } else {
          const user = JSON.parse(localStorage.getItem('pat_user') || '{}');
          this.updateMedicalRecordsIfExists(
            this.telResFormData.tc_booking_id,
            payload.medical_report_id,
            user.user_id,
          );

          this.tosterService.success('Telemedicine updated successfully', '', {
            timeOut: 4000,
          });

          this.teleMedicineConsultForm.reset();

          if (this.datepicker) {
            this.datepicker.bsValue = null;
          }
          (document.getElementById('telemodel') as HTMLElement)?.click();
          setTimeout(() => {
            this.commonService.emitModalClosed();
          }, 0);
          this.commonService.triggerRefreshParentDetail('consultation');
          this.spinner.hide();
        }
      } else {
        this.apiService
          .reschedultTelemedicineConsultant(
            payload,
            this.telResFormData.tc_booking_id,
          )
          .subscribe(
            (res: any) => {
              this.spinner.hide();
              if (res?.success) {
                const sessionData = {
                  data: JSON.stringify(res),
                  expiry: new Date().getTime() + 5 * 60 * 1000,
                };
                sessionStorage.setItem(
                  'tele_consult_status',
                  JSON.stringify(sessionData),
                );
                this.tosterService.success(
                  'Telemedicine rescheduled successfully',
                  '',
                  { timeOut: 4000 },
                );

                this.updateMedicalRecordsIfExists(
                  res.data.tc_booking_id,
                  payload.medical_report_id,
                  res.data.user_id,
                );

                this.teleMedicineConsultForm.reset();

                if (this.datepicker) {
                  this.datepicker.bsValue = null;
                }
                (document.getElementById('telemodel') as HTMLElement)?.click();
                this.commonService.emitModalClosed();
                this.commonService.triggerRefreshParentDetail('consultation');
              } else {
                this.spinner.hide();
                window.scrollTo({ top: 0, behavior: 'smooth' });
                this.tosterService.error(
                  res?.message || 'Failed to update telemedicine consultant.',
                  '',
                  {
                    timeOut: 4000,
                  },
                );
              }
            },
            (err) => {
              this.spinner.hide();
              this.tosterService.error(
                'Failed to telemedicine consultant.',
                '',
                {
                  timeOut: 4000,
                },
              );
              console.error('Error telemedicine consultant:', err);
            },
            () => {
              this.spinner.hide();
              this.isSubmittingtelemedi = false;
            },
          );
      }
    } else if (formValue.plan_consultation === 'Consult Now') {
      const consultNowPayload: any = {
        consultation_type: formValue.consultation_type,
        user_id: formValue.patient.user_id,
        reason_for_consultation: formValue.reason_for_consultation,
        tc_plan_type: 'Consult Now',
        is_al_carte: payload.is_al_carte,
        phone_number:
          this.telemediPatientHasPhone && formValue?.phone?.number
            ? Number(String(formValue.phone.number).replace(/\s/g, ''))
            : null,
        country_dial_code: this.telemediPatientHasPhone
          ? formValue.phone?.dialCode
          : null,
        channel_id: 1,
        currency: payload.is_al_carte ? formValue.currency : null,
        a_la_carte_price: payload.is_al_carte
          ? formValue.a_la_carte_price
          : null,
        caregiver_id: formValue.patient.user_id,
        medical_report_id: formValue?.medical_report_id,
      };

      this.apiService.checkDoctorAvailability().subscribe({
        next: (availRes: any) => {
          if (!availRes?.success) {
            this.spinner.hide();
            this.tosterService.error(
              availRes?.message ||
                'Sorry, No doctors available at this time please book your consultation after some time',
              '',
              { timeOut: 4000 },
            );
            return;
          }
          this.submitConsultNowBooking(consultNowPayload);
        },
        error: () => {
          this.spinner.hide();
          this.tosterService.error(
            'Unable to check doctor availability. Please try again.',
            '',
            { timeOut: 4000 },
          );
        },
      });
    } else {
      this.apiService.bookTelemedicineConsultant(payload).subscribe(
        (res: any) => {
          this.spinner.hide();
          if (res?.success) {
            const sessionData = {
              data: JSON.stringify(res),
              expiry: new Date().getTime() + 5 * 60 * 1000,
            };

            sessionStorage.setItem(
              'tele_consult_status',
              JSON.stringify(sessionData),
            );

            if (res?.data?.is_al_carte) {
              this.tosterService.success(
                'Booking entry created. Please proceed to payment.',
                '',
                { timeOut: 4000 },
              );
            } else {
              this.tosterService.success(
                'Telemedicine booked successfully',
                '',
                {
                  timeOut: 4000,
                },
              );
            }

            const oldStatus = 'Null';
            const newStatus = 'REQUEST';
            const bookingData = res?.data;

            if (
              res?.data?.tc_booking_id &&
              payload.medical_report_id &&
              payload.medical_report_id?.length > 0
            ) {
              this.spinner.show();
              const reqData: any = {
                user_id: res?.data?.user_id,
                tc_booking_id: res?.data?.tc_booking_id,
                medical_report_id: payload.medical_report_id,
              };

              this.apiService.addTelemedicineMedicalRecords(reqData).subscribe({
                next: (response) => {
                  this.spinner.hide();
                },
                error: (error) => {
                  this.spinner.hide();
                  const errorMsg =
                    error?.error?.message ||
                    error?.error?.error ||
                    'An error occurred while adding medical records.';
                  this.tosterService.error(errorMsg);
                },
              });
            }

            this.bookingLogService
              .logBookingAction(
                oldStatus,
                newStatus,
                bookingData,
                'consultation',
              )
              .subscribe(
                (response) => {
                  this.spinner.hide();
                },
                (error) => {
                  this.spinner.hide();
                  this.tosterService.error(
                    error.error.message ||
                      error.error.error ||
                      'An error occurred',
                  );
                },
              );

            (document.getElementById('telemodel') as HTMLElement)?.click();
            this.commonService.emitModalClosed();
            this.teleMedicineConsultForm.reset();
            if (this.datepicker) {
              this.datepicker.bsValue = null;
            }
          } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            this.tosterService.error(
              res?.message || 'Failed to telemedicine consultant.',
              '',
              {
                timeOut: 4000,
              },
            );
          }
        },
        (err) => {
          this.spinner.hide();
          this.tosterService.error('Failed to telemedicine consultant.', '', {
            timeOut: 4000,
          });
          console.error('Error Telemedicine Consultant:', err);
        },
        () => {
          this.spinner.hide();
          this.isSubmittingtelemedi = false;
        },
      );
    }
  }

  private submitConsultNowBooking(consultNowPayload: any): void {
    this.apiService.bookConsultNowTelemedicine(consultNowPayload).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        if (res?.success) {
          const sessionData = {
            data: JSON.stringify(res),
            expiry: new Date().getTime() + 5 * 60 * 1000,
          };

          sessionStorage.setItem(
            'tele_consult_status',
            JSON.stringify(sessionData),
          );

          if (res?.data?.is_al_carte) {
            this.tosterService.success(
              'Booking entry created. Please proceed to payment.',
              '',
              { timeOut: 4000 },
            );
          } else {
            this.tosterService.success('Telemedicine booked successfully', '', {
              timeOut: 4000,
            });
          }

          if (
            res?.data?.tc_booking_id &&
            consultNowPayload.medical_report_id?.length > 0
          ) {
            this.spinner.show();
            const reqData: any = {
              user_id: res?.data?.user_id,
              tc_booking_id: res?.data?.tc_booking_id,
              medical_report_id: consultNowPayload.medical_report_id,
            };
            this.apiService.addTelemedicineMedicalRecords(reqData).subscribe({
              next: () => this.spinner.hide(),
              error: (error) => {
                this.spinner.hide();
                const errorMsg =
                  error?.error?.message ||
                  error?.error?.error ||
                  'An error occurred while adding medical records.';
                this.tosterService.error(errorMsg);
              },
            });
          }

          this.bookingLogService
            .logBookingAction('Null', 'REQUEST', res?.data, 'consultation')
            .subscribe({
              next: () => this.spinner.hide(),
              error: (error) => {
                this.spinner.hide();
                this.tosterService.error(
                  error.error.message ||
                    error.error.error ||
                    'An error occurred',
                );
              },
            });

          (document.getElementById('telemodel') as HTMLElement)?.click();
          this.commonService.emitModalClosed();
          this.teleMedicineConsultForm.reset();
          if (this.datepicker) {
            this.datepicker.bsValue = null;
          }
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          this.tosterService.error(
            res?.message || 'Failed to book consultation.',
            '',
            { timeOut: 4000 },
          );
        }
      },
      error: (err) => {
        this.spinner.hide();
        this.tosterService.error('Failed to book consultation.', '', {
          timeOut: 4000,
        });
        console.error('Error Consult Now Telemedicine:', err);
      },
      complete: () => {
        this.spinner.hide();
        this.isSubmittingtelemedi = false;
      },
    });
  }

  private updateMedicalRecordsIfExists(
    tc_booking_id: any,
    medicalReportIds: any,
    user_id: any,
  ) {
    if (tc_booking_id && medicalReportIds?.length > 0) {
      this.spinner.show();
      const reqData: any = {
        user_id: user_id,
        tc_booking_id: tc_booking_id,
        medical_report_id: medicalReportIds,
      };

      this.apiService.updateTelemedicineMedical(reqData).subscribe({
        next: () => this.spinner.hide(),
        error: (error) => {
          this.spinner.hide();
          const errorMsg =
            error?.error?.message ||
            error?.error?.error ||
            'An error occurred while adding medical records.';
          this.tosterService.error(errorMsg);
        },
      });
    }
  }

  getSlotsData(ev: any): void {
    if (ev) {
      const updatedAppointmentDate = moment(ev).format('YYYY-MM-DD');
      this.teleMedicineConsultForm
        .get('appointment_date')
        .setValue(updatedAppointmentDate);
      const consultationType =
        this.teleMedicineConsultForm.get('consultation_type')?.value;
      let consultTypeId = null;
      if (consultationType == 'Consult with General Physician') {
        consultTypeId = 1;
      } else if (consultationType == 'Consult with Herbalist') {
        consultTypeId = 2;
      }

      const data = {
        consultation_type: consultTypeId,
        date: updatedAppointmentDate,
      };

      this.apiService.getSlots(data).subscribe((res: any) => {
        this.slotsList = res.data || [];
        const isSlotExist = this.slotsList.some(
          (el) => el?.slot_id == this.teleMedicineConsultForm?.value['slot_id'],
        );

        if (!isSlotExist) {
          this.teleMedicineConsultForm.get('slot_id').setValue(null);
        }
      });
    }
  }

  get ageControl() {
    return this.teleMedicineConsultForm.get('age');
  }

  handleReportDate(ev: any) {
    if (ev) {
      const selectedDate = moment(ev).format('YYYY-MM-DD');
      this.medicalForm?.get('treatmentDate')?.setValue(selectedDate);
    }
  }

  closePopup(data: any) {
    this.isUpdated = false;
    this.isReschedule = false;
    if (data == 'consultation') {
      this.teleMedicineConsultForm.reset();
      if (this.datepicker) {
        this.datepicker.bsValue = null;
        this.teleMedicineConsultForm.get('appointment_date')?.markAsPristine();
        this.teleMedicineConsultForm.get('appointment_date')?.markAsUntouched();
      }
    } else {
      if (this.birthdatepicker) {
        this.birthdatepicker.bsValue = null;
      }
    }
  }

  ngAfterViewInit() {
    const modalIds = ['book_amb', 'add_tele'];

    modalIds.forEach((id) => {
      const modalElement = document.getElementById(id);

      if (modalElement) {
        modalElement.addEventListener('shown.bs.modal', () =>
          this.onModalOpened(id),
        );

        modalElement.addEventListener('hidden.bs.modal', () => {
          if (id === 'add_tele') {
            this.closePopup('consultation');
          }
        });
      }
    });

    const closeModalIds = ['add_medical_records_modal'];
    closeModalIds.forEach((id) => {
      const modalElement = document.getElementById(id);
      if (modalElement) {
        modalElement.addEventListener('hidden.bs.modal', () => {
          this.dpMedicalPicker && (this.dpMedicalPicker.bsValue = null);
        });
      }
    });

    const modalEl = document.getElementById('cancel_consultation');

    if (modalEl) {
      modalEl.addEventListener('hidden.bs.modal', () => {
        this.selectedReason = '';
      });
    }

    const minutemodalEl = document.getElementById('set_reminder');

    if (minutemodalEl) {
      minutemodalEl.addEventListener('hidden.bs.modal', () => {
        this.selectedMinute = null;
        this.selectedOptions = [];
      });
    }
  }

  onModalOpened(id: string) {
    if (id === 'book_amb') {
      this.ambulancePatientHasPhone = true;
    }
    if (id === 'add_tele') {
      this.telemediPatientHasPhone = true;
    }
  }

  onlyAlphabet(event: any) {
    const input = event.target as HTMLInputElement;
    let value = input.value;
    value = value.replace(/[^a-zA-Z\s.,-]/g, '');

    input.value = value;
    const controlName = input.getAttribute('formcontrolname');
    if (controlName) {
      this.medicalForm.get(controlName)?.setValue(value, { emitEvent: false });
    }
  }

  onInputChange(event: any) {
    if (this.text.length > this.maxChars) {
      this.text = this.text.slice(0, this.maxChars);
      event.preventDefault();
    }
    this.charCount = this.text.length;
  }

  onRecordChange(event: any): void {
    const selectedReport = this.medicalForm.get('report_type_id')?.value;
    const otherRecordControl = this.medicalForm.get('report_type_description');

    if (selectedReport?.report_type === 'Others') {
      this.selectedRecord = selectedReport?.report_type;
      otherRecordControl?.setValidators([Validators.required]);
    } else {
      this.selectedRecord = selectedReport?.report_type || '';
      otherRecordControl?.clearValidators();
      otherRecordControl?.setValue('');
    }

    otherRecordControl?.updateValueAndValidity();
  }

  getAllMedicalRecordTypes() {
    this.spinner.show();
    this.apiService.getMedicalRecordTypes().subscribe(
      (res: any) => {
        this.medicalReportList = res.data;
        this.spinner.hide();
      },
      (err: any) => {
        console.error('Error fetching medical record types:', err);
        this.spinner.hide();
      },
    );
  }

  getUserUnlockMedicalRecord() {
    this.spinner.show();
    this.userProfiles = JSON.parse(localStorage.getItem('pat_user') || '{}');
    const userId = this.userProfiles?.user_id;
    this.apiService.getUserUnlockMedicals(userId).subscribe(
      (res: any) => {
        setTimeout(() => {
          this.unlockMedicalList = res.data.map((item: any) => {
            let displayText = '';

            if (item.type === 'prescription') {
              const doctorName = item?.doctor
                ? `${item.doctor.first_name} ${item.doctor.last_name}`
                : 'Unknown Doctor';

              displayText = `Prescription - Dr ${doctorName}`;
            } else {
              const recordType =
                item.MedicalRecordType?.report_type || 'Record';
              displayText = `${recordType} - ${item.symptoms || ''}`;
            }

            return {
              id: item.id,
              type: item.type,
              displayText,
            };
          }, 1000);
        });

        this.spinner.hide();
      },
      (err: any) => {
        console.error('Error fetching medical record types:', err);
        this.spinner.hide();
      },
    );
  }

  compareObjects(a: any, b: any) {
    return a && b && a.id === b.id && a.type === b.type;
  }

  closeCancelPopup() {
    this.selectedReason = '';

    const modalEl = document.getElementById('cancel_consultation');
    if (modalEl) {
      const modal = (window as any).bootstrap.Modal.getInstance(modalEl);
      modal?.hide();
    }
  }

  confirmCancel() {
    const bookingId = this.selectedAppointment?.tc_booking_id;

    if (!bookingId) {
      this.tosterService.error('Booking not found');
      return;
    }

    if (!this.selectedReason) {
      this.tosterService.error('Please select reason for cancellation');
      return;
    }

    this.spinner.show();

    this.apiService
      .cancelTelemedicineConsultant(
        { cancel_reason: this.selectedReason },
        bookingId,
      )
      .subscribe({
        next: (res: any) => {
          if (res?.success) {
            this.tosterService.success(
              'Telemedicine Consultant Successfully Cancelled',
              '',
              { timeOut: 4000 },
            );

            this.closeCancelPopup();
          } else {
            this.tosterService.error('Cancellation failed');
          }
        },

        error: (err: any) => {
          console.error('Cancel error:', err);
          this.tosterService.error('Something went wrong. Please try again.');
        },

        complete: () => {
          this.spinner.hide();
        },
      });
  }

  submitRating() {
    const bookingId = this.selectedAppointment?.tc_booking_id;
    const userId = this.selectedAppointment?.user_id;

    if (!bookingId || !userId) {
      this.tosterService.error('Invalid data');
      return;
    }

    if (!this.rating) {
      this.tosterService.error('Please select rating');
      return;
    }

    const qa = Object.keys(this.selectedAnswers).map((qId: any) => ({
      question_id: Number(qId),
      answer_id: this.selectedAnswers[qId],
    }));

    this.spinner.show();

    const payload = {
      userId: userId,
      bookingId: bookingId,
      featureServiceId: 2,
      rating: this.rating,
      review: this.review,
      qa: qa,
    };

    this.apiService.addRating(payload).subscribe({
      next: (res: any) => {
        if (res?.success) {
          this.tosterService.success('Rating Successfully Submitted', '', {
            timeOut: 4000,
          });

          const modalEl = document.getElementById('rating_modal');
          if (modalEl) {
            const modal = (window as any).bootstrap.Modal.getInstance(modalEl);
            modal?.hide();
          }

          this.rating = 0;
          this.review = '';
          this.selectedAnswers = {};
        } else {
          this.tosterService.error('Rating failed');
        }
      },

      error: (err: any) => {
        console.error('Cancel error:', err);
        this.tosterService.error('Something went wrong. Please try again.');
      },

      complete: () => {
        this.spinner.hide();
      },
    });
  }

  setReminder() {
    const bookingId = this.selectedAppointment?.tc_booking_id;

    if (!bookingId) {
      this.tosterService.error('Booking not found');
      return;
    }

    if (!this.selectedMinute) {
      this.tosterService.error('Please select reminder time');
      return;
    }

    if (!this.selectedOptions.length) {
      this.tosterService.error(
        'Please select at least one notification method',
      );
      return;
    }

    this.spinner.show();

    const reqData = {
      tc_booking_id: bookingId,
      reminder_before: this.selectedMinute,
      channels: this.selectedOptions,
    };

    this.apiService.addReminder(reqData).subscribe({
      next: (res: any) => {
        if (res?.success) {
          this.tosterService.success('Set Reminder Successfully', '', {
            timeOut: 4000,
          });

          const modalEl = document.getElementById('set_reminder');
          if (modalEl) {
            const modal = (window as any).bootstrap.Modal.getInstance(modalEl);
            modal?.hide();
          }

          this.selectedMinute = null;
          this.selectedOptions = [];
        } else {
          this.tosterService.error('Set Reminder failed');
        }
      },

      error: (err: any) => {
        console.error('Cancel error:', err);
        this.tosterService.error('Something went wrong. Please try again.');
      },

      complete: () => {
        this.spinner.hide();
      },
    });
  }

  toggleOption(option: string) {
    if (this.selectedOptions.includes(option)) {
      this.selectedOptions = this.selectedOptions.filter((o) => o !== option);
    } else {
      this.selectedOptions.push(option);
    }
  }

  openRatingFromSummary() {
    const summaryEl = document.getElementById('view_summary_modal');
    if (summaryEl) {
      (window as any).bootstrap.Modal.getInstance(summaryEl)?.hide();
    }

    const ratingEl = document.getElementById('rating_modal');
    if (ratingEl) {
      (window as any).bootstrap.Modal.getOrCreateInstance(ratingEl).show();
    }
  }

  openChatFromSummary() {
    const summaryEl = document.getElementById('view_summary_modal');
    if (summaryEl) {
      (window as any).bootstrap.Modal.getInstance(summaryEl)?.hide();
    }

    this.commonService.triggerOpenChat(this.selectedAppointment);
  }

  getRatingText(value: number): string {
    switch (value) {
      case 1:
        return 'Terrible';
      case 2:
        return 'Poor';
      case 3:
        return 'Good';
      case 4:
        return 'Very Good';
      case 5:
        return 'Excellent';
      default:
        return '';
    }
  }

  getInitials(): string {
    const firstName = this.selectedAppointment?.doctor_first_name || '';
    const lastName = this.selectedAppointment?.doctor_last_name || '';

    const firstInitial = firstName.charAt(0).toUpperCase();
    const lastInitial = lastName.charAt(0).toUpperCase();

    return firstInitial + lastInitial;
  }

  setRating(value: number) {
    if (this.rating === value) return;
    this.rating = value;
  }

  selectAnswer(questionId: number, answerId: number) {
    this.selectedAnswers[questionId] = answerId;
  }

  getPatientAge(dob: string): number | null {
    if (!dob) return null;

    const birthDate = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();

    const monthDifference = today.getMonth() - birthDate.getMonth();

    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  }
}
